import React from 'react';
import { Form, Select } from 'antd';

const Level = () => {
    return (
        <Form.Item
            label="Poziom trudności"
            name="difficultyLevel"
            rules={[
                {
                    required: true,
                    message: 'Proszę podać poziom trudności',
                },
            ]}
        >
            <Select>
                <Select.Option value={1}>Łatwa</Select.Option>
                <Select.Option value={2}>Średnia</Select.Option>
                <Select.Option value={3}>Trudna</Select.Option>
            </Select>
        </Form.Item>
    );
};

export default Level;
